// ### Functions removes all whitespace from string

export const removeWhitespace = (input: string) => {
    return input.toString().replace(/ /g, '').trim();
};
